import {Entity} from "../../core/commons/entity";
/**
 * Created by Lauta on 15/3/2017.
 */
export class WordpressPost implements Entity{
    id: number;
    title: string;
    paragraphs: string[];
    excerpt: string;
    image: string;
    link: string;
    constructor(value: Object = {}) {
        Object.assign(this, value);
    }


    public limitWords(n : number) : string{
        let text = [];
        for (let i = 0 ; i < this.paragraphs.length ; i++){
            let p = this.paragraphs[i].split(" ");
            if ( text.length <= n ) {
                text = text.concat( p.splice(0,n - text.length) ).concat("<br>");
            }
        }
        if (text.length > 1) {
            text[text.length - 1] = "... " + text[text.length - 1];
            return text.join(" ");
        }
        return null;
    }


}


// WEBPACK FOOTER //
// ./src/app/fiscalia/domain/wordpress-post.ts